import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  alertContainer: {
    margin: theme.spacing(2, 0)
  }
}));
